import React, { Fragment, useState, useEffect } from "react";
import QrReader from 'react-qr-scanner'
import { useNavigate, useLocation } from "react-router";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import FContainer from '../../components/FContainer/FContainer';
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import { useProcessor } from "../../hooks/useProcessor";
import { v4 as uuidv4 } from 'uuid';

const QrStaticScreen = ({ param }) => {
  const route = useNavigate();
  const { state } = useLocation();
  const [idempotencyKey, setIdempotencyKey] = useState(null);
  const { processPayment } = useProcessor();

  useEffect(() => {
    setIdempotencyKey(uuidv4());
  }, []);

  const nextScreen = async (data, idempotencyKey) => {
    let response = await processPayment(data, idempotencyKey);
    if (response?.data?.code == "PROCESS_OK") {
      Swal.fire({
        showCloseButton: true,
        title: 'Éxito',
        text: 'La transferencia se ha realizado exitosamente',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          route("/ShareFiadoScreen")
        } else {
          route("/ShareFiadoScreen")
        }
      })
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "Su solicitud no puede ser procesada",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        confirmButtonText: 'Entendido'
      })
    }
  }


  const formik = useFormik({
    initialValues: {
      amount: 0,
      concept: '',
    },
    onSubmit: (values) => {
      const { amount, concept } = values;
      const monto = parseInt(amount)

      const data = {
        originCurrencyId: "484",
        destinationCurrencyId: "484",
        exchangeRateId: null,
        products: [
          {
            id: "FIADO_FUNDS_AVAILABLE_MXN"
          },
          {
            id: "FIADO_SHARE_MXN",
            amount: monto,
            beneficiaryDirectoryId: state.directoryId,
            typeOfDirectoryId: JSON.parse(localStorage.getItem("tokenDecoded")).typeOfDirectoryId,
            concept: concept,
            saveAsFavorite: false
          }

        ]
      }

      nextScreen(data, idempotencyKey)
    },
    validate: (values) => {
      const errors = {};

      if (values.amount == 0) {
        errors.amount = "El monto debe ser mayor a 0";
      }

      if (values.concept == '') {
        errors.concept = "Ingresa el concepto.";
      }

      return errors;
    },
  })


  useEffect(() => {
    formik.setFieldValue(
      "number",
      ""
    );
  }, [])


  return (
    <>    {!state ? route("/ShareFiadoScreen") :
      <FContainer>
      <div className="font-bold text-[17px]">Para: {state.name}</div>
        <FInputText
          type="CurrencyInput"
          title={"Cantidad (MXN)"}
          laceholder="¿Cuánto?"
          value={formik.values.amount}
          maxLength={10}
          onChange={async (value) => {
            formik.setFieldValue("amount", value == undefined ? 0 : value);
          }}
          errorMessage={
            formik.errors.amount
          }
        />

        <FInputText title={"Concepto"} placeholder={"Concepto"} value={formik.values.concept} onChange={(value) => {
          formik.setFieldValue(
            "concept",
            value
          );
        }} />

        <Fbutton
          value={"Enviar"}
          disabled={!formik.isValid}
          onClick={formik.handleSubmit}
        />
      </FContainer>}
    </>
  );
};

export default QrStaticScreen;
